module.exports = __webpack_public_path__ + "img/inscripcionesjcyl.b9b7b46e.png";